import { render } from "./AddComment.vue?vue&type=template&id=9b0e806a&scoped=true&ts=true"
import script from "./AddComment.vue?vue&type=script&lang=ts"
export * from "./AddComment.vue?vue&type=script&lang=ts"

import "./AddComment.vue?vue&type=style&index=0&id=9b0e806a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b0e806a"]])

export default __exports__